import * as currencyFormats from '@square/dashboard-translations/utils/formats/currency';
import Service from '@ember/service';
export default class CurrencyService extends Service {
  /**
   * Convert value into smallest divisible unit of currency for a given locale
   *
   * @param {Number} value
   * @param {String} currencyCode
   */
  amount(value, currencyCode = 'USD') {
    const currencyFormat = currencyFormats[currencyCode] || currencyFormats.standard;
    return value * Math.pow(10, -currencyFormat.exponent);
  }

  /**
   * Convert amount into human readable value
   *
   * @param {Number} amount
   * @param {String} currencyCode
   */
  value(amount, currencyCode = 'USD') {
    const currencyFormat = currencyFormats[currencyCode] || currencyFormats.standard;
    return amount * Math.pow(10, currencyFormat.exponent);
  }
}